import React from 'react'
import Layout from '../../components/admin/Layout'
import StaterCard from '../web/StaterCard'

function Dashboard() {
  return (
    <div>
      <Layout>
        <h1 className='text-2xl font-bold'>Admin Dashboard</h1>
        <StaterCard/>
      </Layout>
    </div>
  )
}

export default Dashboard
